























































































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class ChallengePage extends Vue {
  organizers = [
    {
      name:'Ning Xu',
      affiliation:'Adobe Research',
      im_name:'NingXu',
      link: 'http://sites.google.com/view/ningxu/',
    }, {
      name:'Linjie Yang',
      affiliation:'ByteDance AI Lab',
      im_name:'LinjieYang',
      link: 'https://sites.google.com/site/linjieyang89/',
    }, {
      name:'Yuchen Fan',
      affiliation:'UIUC',
      im_name:'YuchenFan',
      link: 'https://ece.illinois.edu/directory/profile/yuchenf4',
    }, {
      name: 'Brian Price',
      affiliation: 'Adobe Research',
      im_name:'BrianPrice',
      link: 'https://www.brianpricephd.com/',
    }, {
      name: 'Weiyao Lin',
      affiliation: 'SJTU',
      im_name: 'WeiyaoLin',
      link: 'https://weiyaolin.github.io/',
    }, {
      name: 'Michael Ying Yang',
      affiliation: 'U of Twente',
      im_name: 'MichaelYingYang',
      link: 'https://sites.google.com/site/michaelyingyang/',
    }, {
      name: 'Jianchao Yang',
      affiliation: 'ByteDance AI Lab',
      im_name: 'JianchaoYang',
      link: 'http://www.ifp.illinois.edu/~jyang29/',
    }, {
      name: 'Jiebo Luo',
      affiliation: 'U of Rochester',
      im_name: 'JieboLuo',
      link: 'http://www.cs.rochester.edu/u/jluo/',
    }, {
      name: 'Thomas Huang',
      affiliation: 'UIUC',
      im_name: 'Tom',
      link: 'https://ece.illinois.edu/directory/profile/t-huang1'
    },
  ]
  sponsors = [
    {name:'Snapchat', im_name:'snapchat.jpg'},
    {name:'Adobe',  im_name:'adobe.png'},
    {name:'UIUC', im_name:'uiuc.jpg'},
    {name:'CAS', im_name:'cas.jpg'},
  ]
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/challenge.vue